import deepmerge from 'deepmerge';

export function mapOldLayoutOptions(options, presentationData, quizzesEnabled) {
    const Presentation = presentationData.presentationOptions

    const commandMapping = {
        AllowAskQuestion: value => ({
            askAQuestion: {
                enabled: (value && Presentation?.ForumEnabled) ?? false
            },
        }),
        AllowChapterNavigation: value => ({
            chapters: {
                showChapterList: value ?? true,
            }
        }),
        AllowDownloads: value => ({
            downloads: {
                enabled: value ?? false
            }
        }),
        AllowFullscreen: value => ({
            settings: {
                enableFullScreen: value ?? true
            }
        }),
        AllowHelp: value => ({
            help: {
                enabled: value === false ? false : presentationData?.playerOptions?.help?.url ? true : false
            }
        }),
        AllowPlayPauseStop: value => ({
            settings: {
                enablePlayPause: value ?? true
            }
        }),
        AllowPolls: value => ({
            polls: {
                enabled: value && Presentation?.PollingEnabled && presentationData?.playerOptions?.polls?.url
            }
        }),
        AllowPopout: value => ({
            popout: {
                enabled: value
            }
        }),
        PopOutBehavior: value => ({
            popout: {
                enabled: (value === "Always" || value === "Embedded")
            }
        }),
        AllowScrubbing: value => ({
            settings: {
                enableSeeking: !((quizzesEnabled && quizzesEnabled === false) || (!quizzesEnabled && value === false))
            }
        }),
        AllowShare: value => ({
            share: {
                enabled: value === true && Presentation.SharingEnabled === true
            }
        }),
        AllowSpeedControl: value => ({
            settings: {
                enableSpeedControl: value ?? true
            }
        }),
        EnablePIP: value => ({
            settings: {
                enablePIP: value ?? true
            }
        }),
        EnablePresentationInfo: value => ({
            metadata: {
                showControlBarButton: value ?? true,
            }
        }),
        EnableSearch: value => ({
            search: {
                enabled: value === true && Presentation?.HasSearchableText === true
            }
        }),
        ShowDateTime: value => ({
            metadata: {
                showPublishDateTime: value ?? true
            }
        }),
        ShowHeaderArea: value => ({
            banner: {
                enabled: (value == 'Disabled' || value == false) ? false : presentationData?.playerOptions?.banner?.src ? true : false,
                behavior: (value == 'AutoHide' || value == 'Static') ? value : value === true ? 'AutoHide' : 'Disabled'
            }
        }),
        ShowMainControls: value => ({
            controls: value ?? true
        }),
        // ForceBalanced: {},
        // :SideBias: {},
        ShowStateMessages: value => ({
            banner: {
                endedEnabled: value
            }
        }),
        Margin: {}, // Todo
        // Gutter: {},
        // FrameWidth: {},
        // FrameColor: {},
        // FrameOpacity: {},
        BackgroundColor: value => ({
            settings: {
                backgroundColor: value
            }
        })
    }
    const mappedLayoutOptions = Object.entries(options).reduce((all, [key, value]) => {
        const mappedCommandFn = commandMapping[key];
        if (mappedCommandFn) {
            all.push(mappedCommandFn(value));
        }
        else {
            all.push({
                [key]: value
            });
        }
        return all;
    }, []);
    const merged = deepmerge.all(mappedLayoutOptions);
    if (merged?.settings?.enableSeeking === false ||
        (merged?.settings?.enableSeeking == null && presentationData.playerOptions.settings.enableSeeking === false))
    {
        if (!merged.search) {
            merged.search = {};
        }
        if (!merged.chapters) {
            merged.chapters = {};
        }
        merged.search.enabled = false;
        merged.chapters.showChapterList = false;
    }
    return merged;
}
